(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Interval", [], factory);
	else if(typeof exports === 'object')
		exports["Interval"] = factory();
	else
		root["Interval"] = factory();
})(self, () => {
return 